import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import pageConfig from '@PROJECT_ROOT/responsiveFrontendPagesConfiguration.json';
import AboutGuaranteesContent from '@PROJECT_ROOT/assets/responsive-frontend/pages/AboutGuarantees/AboutGuaranteesContent';
import GlobalPageComponents from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/globalPageComponents';
import initAfterContentComponent from '@PROJECT_ROOT/assets/responsive-frontend/js/services/AfterContentComponent';
import initMobileFixedButtonsWhereItsOnlySearch from '@PROJECT_ROOT/assets/responsive-frontend/js/services/initMobileFixedButtonsWhereItsOnlySearch';

const rootEl = document.getElementById(pageConfig.aboutGuaranteesPage.id);
if (rootEl) {
    const ssrData = window.SSR_DATA || null;
    hydrateRoot(
        rootEl,
        <>
            <GlobalPageComponents />
            <AboutGuaranteesContent publicResourcesSSR={ssrData} />
        </>,
    );
}
initAfterContentComponent();
initMobileFixedButtonsWhereItsOnlySearch();
